<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title has-text-weight-medium">
                Inventory Feedback
            </p>
            <button
                class="delete"
                aria-label="close"
                @click="$parent.close()"
            />
        </header>
        <section class="modal-card-body">
            <form
                v-if="$meta.features.tenants.inventory_feedback"
                @submit.prevent="submit"
            >
                <FormNotification />

                <SavingNotification>
                    Sending...
                </SavingNotification>

                <b-field label="Feedback on your inventory">
                    <b-input
                        v-model="Message"
                        v-validate="{ required: true, min: 3 }"
                        type="textarea"
                        name="Message"
                    />
                </b-field>

                <b-button
                    type="is-info"
                    tag="button"
                    :disabled="isSending || isSuccess"
                    native-type="submit"
                >
                    Submit
                </b-button>
            </form>
        </section>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Form from '../mixins/form';

export default {
    mixins: [
        Form,
    ],

    computed: {
        ...mapState('tenancyProperty', [
            'tenancy',
        ]),
        ...mapFields('inventoryFeedback', [
            'Message',
        ]),
    },

    methods: {
        submit() {
            this.isSuccess = null;

            this.validate()
            .then((result) => {
                if (! result) {
                    return this.parseClientErrors();
                }

                this.isSending = true;

                this.$store.dispatch('inventoryFeedback/submit', this.tenancy.TenancyPK)
                .then((response) => {
                    this.statusMessage = response.data.message;
                    this.statusType = 'success';
                    this.isSuccess = true;
                })
                .catch((error) => {
                    this.parseServerErrors(error);
                    this.isSuccess = false;
                })
                .then(() => {
                    this.isSending = false;
                });
            });
        },
    },
};
</script>
